module.exports = __webpack_public_path__ + "static/shape14-9453c1e87da644af2a452eb2df8013ec.png";